import { OperatorFunction } from 'rxjs/interfaces';
import { ObservableInput } from 'rxjs/Observable';
import { mergeAll as mergeAllRxJS } from 'rxjs/operators';

/**
 * The definition for mergeAll is broken in RxJS 5.5.
 * https://github.com/ReactiveX/rxjs/issues/2759
 *
 * This takes the function signatures fron RxJS 6.0 alpha
 * and uses them to wrap the build in RxJS 5.5 function.
 */
export function mergeAll<T>(
  concurrent?: number,
): OperatorFunction<ObservableInput<T>, T>;
export function mergeAll<R>(concurrent?: number): OperatorFunction<any, R>;

export function mergeAll<T>(concurrent?: number): OperatorFunction<any, T> {
  return mergeAllRxJS(concurrent);
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/operators/mergeAll.ts